module.exports = __webpack_public_path__ + "img/1_031.45acfd42.jpg";